import {
  Box,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Text,
} from "@chakra-ui/react";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import { useNavigate, useParams } from "react-router-dom";
import ApprovedTC from "./ApprovedTC";
import RollbackedTC from "./RollbackedTC";
import { useState, useEffect } from "react";
import isAllowed from "../../../routing/isAllowed";

const HomeTC = () => {
  const [page, setPage] = useState(0);
  const [isActive, setIsActive] = useState(0);
  const [status, setStatus] = useState("idle");
  const STEP_PAGES = [
    {
      id: 0,
      component: () => <ApprovedTC />,
    },
    {
      id: 1,
      component: () => <RollbackedTC />,
    },
  ];
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabClick = (tabIndex) => {
    setPage(tabIndex);
    // Updates localStorage with new active tab index
    localStorage.setItem("activeTabForTC", tabIndex);
  };

  useEffect(() => {
    let storedActiveTab = localStorage.getItem("activeTabForTC") || 0;
    if (storedActiveTab > STEP_PAGES.length - 1) {
      storedActiveTab = 0;
    }
    setPage(parseInt(storedActiveTab));
    setIsActive(parseInt(storedActiveTab));
  }, [page, isActive]);

  return (
    <Box>
      <Tabs variant="line">
        <TabList>
          <Tab
            fontWeight={"700"}
            index={0}
            onClick={() => {
              handleTabClick(0);
            }}
          >
            Approved TC
          </Tab>
          <Tab
            fontWeight={"700"}
            index={1}
            onClick={() => {
              handleTabClick(1);
            }}
          >
            RollBacked TC
          </Tab>
        </TabList>

        <TabPanels>{STEP_PAGES[page]?.component()}</TabPanels>
      </Tabs>
    </Box>
  );
};

export default isAllowed(HomeTC);
